// extracted by mini-css-extract-plugin
export default {"container":"Ja0lRmY6"};